import { request } from "../../utils/config"

export const GET_CATEGORIES = async (params) => {
  const response = await request({
    url: `productCategory`,
    method: "GET",
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_CATEGORY = async (id: string) => {
  const response = await request({
    url: `productCategory/${id}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
